import { ContextStore } from "stores/contextStore";

const STORAGE_KEY = "contextStore";

export class OrganizationContextStorage {
  static set(contextObject: ContextStore) {
    const contextString = JSON.stringify(contextObject);
    
    sessionStorage.setItem(STORAGE_KEY, contextString);
    localStorage.setItem(STORAGE_KEY, contextString);
  }

  static get() {
    const contextString =
      sessionStorage.getItem(STORAGE_KEY) ?? localStorage.getItem(STORAGE_KEY);

    return contextString ? (JSON.parse(contextString) as ContextStore) : null;
  }

  static clear() {
    sessionStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_KEY);
  }
}
